module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Criar novo tipo de bolsa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Código",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.bolsa.codigo),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "codigo", $$v)
      },
      expression: "bolsa.codigo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Unidade",
      "items": _vm.listaPermissoesUnidades,
      "item-text": "nome",
      "item-value": "id",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.unidade.id),
      callback: function($$v) {
        _vm.$set(_vm.bolsa.unidade, "id", $$v)
      },
      expression: "bolsa.unidade.id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Descrição",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.bolsa.descricao),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "descricao", $$v)
      },
      expression: "bolsa.descricao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Valor (R$)",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.bolsa.valor),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "valor", $$v)
      },
      expression: "bolsa.valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número de bolsas disponibilizadas",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.bolsa.vagasOferecidas),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "vagasOferecidas", $$v)
      },
      expression: "bolsa.vagasOferecidas"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtInicio),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtInicio", $$v)
      },
      expression: "bolsa.dtInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtFim),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtFim", $$v)
      },
      expression: "bolsa.dtFim"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "label": "Anexar arquivo comprobatório da concessão das bolsas (pdf)",
      "accept": ".pdf",
      "show-size": "",
      "outlined": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo),
      callback: function($$v) {
        _vm.arquivo = $$v
      },
      expression: "arquivo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarBolsa
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e518a7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/criar-bolsa.vue
// module id = 377
// module chunks = 0